import React from "react";

import arrayDownload from "img/arrow-download.svg";

import IDevolutionInvoiceDownloadButtonProps from "./interface";

import DownloadService from "services/download.service";

import { ActionButton } from "components/ModelButton";
import { eventName } from 'components/ApplicationInsights/eventNames';

const DevolutionInvoiceDownloadButton: React.FC<IDevolutionInvoiceDownloadButtonProps> = (props) => {
    const { textButton, trackName, downloadType, order, className } = props;

    const _downloadService = new DownloadService();

    return (
        <ActionButton
            img={arrayDownload}
            textButton={textButton}
            trackName={trackName}
            trackItem={eventName.DEVOLUCAO_NFE}
            noTracking={true}
            className={className}
            action={() =>
                _downloadService.OpenFileFromOrder(downloadType, order)
            }
        />
    );
};

export default DevolutionInvoiceDownloadButton;